import './app';
import './ticketService';
import './ticketValidationService';

export default '7Terminal.Tickets';
